import React from 'react';
import {useDispatch} from "react-redux";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import {PermissionAction, ResourceName, UserBasicData} from "./types";
import {PERMISSION_ACTIONS, RESOURCE_PATHS, RESOURCES} from "../../config/permissions";
import ability from "../../utils/ability";


function getKeyByValue(object: any, value:string) {
    return Object.keys(object).find(key => object[key] === value);
}

const RequireAuth = () => {
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem('user')  || "{}") as UserBasicData || {};
    const token = Object.keys(user).length  && user.accessToken;
    if (token) {
        try {
            const decoded = jwtDecode(token);
        } catch (error) {
        }
    }
    const location = useLocation();

    console.log(ability)

    //setup new home page if user has no permissions to index drafts
    if (location.pathname === "/" && !ability.can('index', 'Draft')) {
        let redirectPath = null
        RESOURCES.forEach((resource) => {
            for (let i = 0, len = PERMISSION_ACTIONS.length; i < len; i++) {
                if (ability.can(PERMISSION_ACTIONS[i], resource) && RESOURCE_PATHS[resource][PERMISSION_ACTIONS[i]]) {
                    redirectPath = RESOURCE_PATHS[resource][PERMISSION_ACTIONS[i]];
                    break;
                }
            }
        })
        return <Navigate to={redirectPath === null ? '/login' : redirectPath} state={{from: location}} replace></Navigate>;
    }

    // check if user has access to page, if not redirect to 404
    for (const resource in RESOURCE_PATHS) {
        for (const action in RESOURCE_PATHS[resource as ResourceName]) {
            if (RESOURCE_PATHS[resource as ResourceName][action] === location.pathname.split('?')[0] && !ability.can(action as PermissionAction , resource as ResourceName)) {
                return <Navigate to={'/404'} state={{from: location}} replace></Navigate>;
            }
        }
    }

    return (token ? <Outlet/> : <Navigate to={'/login'} state={{from: location}} replace></Navigate>)
}

export default RequireAuth;